import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { configureAmplify, AuthProvider, ThemeProvider } from '@trafiflow/shared-ui'
import App from './App.tsx'
import { AUTH_CONFIG } from './shared/config'
import './lib/i18n'
import './index.css'

// Configurar Amplify
configureAmplify({
  Auth: {
    Cognito: {
      userPoolId: AUTH_CONFIG.userPoolId,
      userPoolClientId: AUTH_CONFIG.userPoolClientId,
      region: AUTH_CONFIG.region,
    },
  },
})

const queryClient = new QueryClient()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)













